/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var t;
!function (t) {
  t[t.NotStarted = 0] = "NotStarted", t[t.Running = 1] = "Running", t[t.Stopped = 2] = "Stopped";
}(t || (t = {}));
var n = {
  type: "xstate.init"
};
function e(t) {
  return void 0 === t ? [] : [].concat(t);
}
function r(t) {
  return {
    type: "xstate.assign",
    assignment: t
  };
}
function i(t, n) {
  return "string" == typeof (t = "string" == typeof t && n && n[t] ? n[t] : t) ? {
    type: t
  } : "function" == typeof t ? {
    type: t.name,
    exec: t
  } : t;
}
function o(t) {
  return function (n) {
    return t === n;
  };
}
function a(t) {
  return "string" == typeof t ? {
    type: t
  } : t;
}
function u(t, n) {
  return {
    value: t,
    context: n,
    actions: [],
    changed: !1,
    matches: o(t)
  };
}
function c(t, n) {
  void 0 === n && (n = {});
  var r = {
    config: t,
    _options: n,
    initialState: {
      value: t.initial,
      actions: e(t.states[t.initial].entry).map(function (t) {
        return i(t, n.actions);
      }),
      context: t.context,
      matches: o(t.initial)
    },
    transition: function (n, c) {
      var s,
        f,
        l = "string" == typeof n ? {
          value: n,
          context: t.context
        } : n,
        v = l.value,
        p = l.context,
        g = a(c),
        y = t.states[v];
      if (y.on) {
        var d = e(y.on[g.type]),
          x = function (n) {
            if (void 0 === n) return {
              value: u(v, p)
            };
            var e = "string" == typeof n ? {
                target: n
              } : n,
              a = e.target,
              c = void 0 === a ? v : a,
              s = e.actions,
              f = void 0 === s ? [] : s,
              l = e.cond,
              d = p;
            if ((void 0 === l ? function () {
              return !0;
            } : l)(p, g)) {
              var x = t.states[c],
                m = !1,
                h = [].concat(y.exit, f, x.entry).filter(function (t) {
                  return t;
                }).map(function (t) {
                  return i(t, r._options.actions);
                }).filter(function (t) {
                  if ("xstate.assign" === t.type) {
                    m = !0;
                    var n = Object.assign({}, d);
                    return "function" == typeof t.assignment ? n = t.assignment(d, g) : Object.keys(t.assignment).forEach(function (e) {
                      n[e] = "function" == typeof t.assignment[e] ? t.assignment[e](d, g) : t.assignment[e];
                    }), d = n, !1;
                  }
                  return !0;
                });
              return {
                value: {
                  value: c,
                  context: d,
                  actions: h,
                  changed: c !== v || h.length > 0 || m,
                  matches: o(c)
                }
              };
            }
          };
        try {
          for (var m = function (t) {
              var n = "function" == typeof Symbol && t[Symbol.iterator],
                e = 0;
              return n ? n.call(t) : {
                next: function () {
                  return t && e >= t.length && (t = void 0), {
                    value: t && t[e++],
                    done: !t
                  };
                }
              };
            }(d), h = m.next(); !h.done; h = m.next()) {
            var S = x(h.value);
            if ("object" == typeof S) return S.value;
          }
        } catch (t) {
          s = {
            error: t
          };
        } finally {
          try {
            h && !h.done && (f = m.return) && f.call(m);
          } finally {
            if (s) throw s.error;
          }
        }
      }
      return u(v, p);
    }
  };
  return r;
}
var s = function (t, n) {
  return t.actions.forEach(function (e) {
    var r = e.exec;
    return r && r(t.context, n);
  });
};
function f(e) {
  var r = e.initialState,
    i = t.NotStarted,
    o = new Set(),
    u = {
      _machine: e,
      send: function (n) {
        i === t.Running && (r = e.transition(r, n), s(r, a(n)), o.forEach(function (t) {
          return t(r);
        }));
      },
      subscribe: function (t) {
        return o.add(t), t(r), {
          unsubscribe: function () {
            return o.delete(t);
          }
        };
      },
      start: function () {
        return i = t.Running, s(r, n), u;
      },
      stop: function () {
        return i = t.Stopped, o.clear(), u;
      },
      get state() {
        return r;
      },
      get status() {
        return i;
      }
    };
  return u;
}
export { t as InterpreterStatus, r as assign, c as createMachine, f as interpret };